import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";

import { postReport, resourcesReports } from "../../../helpers/backend_helper";

import {
  downloadFile,
  getBase64File,
  getMimeHeaders,
} from "../../../helpers/file";

const useExport = ({ filters, reportName, fileNamePrefix, isUnitReport }) => {
  const chartRef = useRef(null);

  const [modalPdf, setModalPdf] = useState({ show: false, url: "" });

  const [isDownloadingGraph, setIsDownloadingGraph] = useState(false);
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);

  const fileName = `${fileNamePrefix}-${isUnitReport ? "unidad" : "operador"}`;

  const handleDownloadReport = (fileType) => {
    const config = {
      params: filters,
      headers: getMimeHeaders(fileType),
      responseType: "blob",
    };

    setIsDownloadingReport(true);
    resourcesReports("show", config, reportName)
      .then(async (blob) => {
        if (fileType == 1) {
          downloadFile(blob, `${fileName}.xlsx`);
        } else {
          const base64File = await getBase64File(blob);

          setModalPdf({ show: true, url: base64File });
        }
      })
      .finally(() => setIsDownloadingReport(false));
  };

  const handleDownloadGraph = async () => {
    const chartElement = chartRef.current.getEchartsInstance().getDom();
    const canvas = await html2canvas(chartElement);
    const imageData = canvas.toDataURL("image/png");

    const data = {
      ...filters,
      image: imageData,
      download_graph: true,
      report_name: reportName,
    };

    const config = {
      responseType: "blob",
    };

    setIsDownloadingGraph(true);
    postReport(data, config)
      .then((blob) => {
        downloadFile(blob, `${fileName}.pdf`);
      })
      .finally(() => {
        setIsDownloadingGraph(false);
      });
  };

  return {
    chartRef,
    modalPdf,
    fileName,
    setModalPdf,
    isDownloadingGraph,
    isDownloadingReport,
    handleDownloadGraph,
    handleDownloadReport,
  };
};

export default useExport;
